import AutoResponderMixin from "../../../mixins/auto-responder-mixin";

Vue.component("mailboxes", {
    mixins: [AutoResponderMixin],
    props: ["mailboxes"],
    data () {
        return {
            mailboxList: this.mailboxes,
            selectedMailbox: null,
            form: new AppForm({})
        };
    },
    computed: {
        hasMailboxes () {
            return this.mailboxList !== undefined && this.mailboxList.length > 0;
        },
        showMailboxForm () {
            return this.selectedMailbox !== null;
        }
    },
    methods: {
        showMailboxCreateView () {
            if (this.app.state.mailboxes_remaining <= 0) {

                let text = this.app.state.pricing_plan === "limited" ?
                    "Premium accounts have 20 mailboxes included. Would you like to upgrade?" :
                    "Contact support to get more mailboxes.";

                let confirmButton = this.app.state.pricing_plan === 'limited' ? "Yes, Let's upgrade!" : 'Ok';

                swal({
                    title: "Mailbox Limit Reached!",
                    text: text,
                    icon: "warning",
                    showCancelButton: this.app.state.pricing_plan === "limited",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: confirmButton,
                    cancelButtonText: "Close"
                }).then((result) => {
                    if (result.value && this.app.state.pricing_plan === 'limited') {
                        window.location = "/settings#/tab-billing";
                    }
                });
            } else {
                window.location = '/settings/mailboxes/create';
            }
        },
        mailboxAutoresponderStatus (mailbox) {
            if (_.isUndefined(mailbox.autoresponder) || mailbox.autoresponder === null) {
                return false;
            }
            return mailbox.autoresponder.status;
        },
        viewMailbox (mailbox) {
            this.selectedMailbox = mailbox;
        },
        closeMailboxForm () {
            this.selectedMailbox = null;
        },
        mailboxUpdated (mailbox) {
            this.mailboxList[this.mailboxList.indexOf(this.selectedMailbox)] = mailbox;
            this.selectedMailbox = mailbox;
        },
        updateMailboxAutoResponder (autoresponder, mailboxId) {
            this.mailboxList[_.findIndex(this.mailboxList, (mailbox) => { return mailbox.id === mailboxId; })].autoresponder = autoresponder;
        },
        addAutoResponderAttachment (mailboxId, attachment) {
            let targetedAutoResponder = this.mailboxList[_.findIndex(this.mailboxList, (mailbox) => { return mailbox.id === mailboxId; })].autoresponder;
            targetedAutoResponder.media.push(attachment);
        },
        removeAutoResponderAttachment (mailboxId, attachmentId) {
            let targetedAutoResponder = this.mailboxList[_.findIndex(this.mailboxList, (mailbox) => { return mailbox.id === mailboxId; })].autoresponder;
            targetedAutoResponder.media.splice(
                _.findIndex(targetedAutoResponder.media, m => { return m.id === attachmentId; }),
                1
            );
        }
    }
});
